import {Box, Text, Image, Heading, Flex, Center} from '@chakra-ui/react';
import * as React from 'react';
import {SlideInBox} from './slide-in-box';

export const ExperienceBanksy: React.FC = () => {
  return (
    <Center mb="100px">
      <Box w="100%" maxW="1080" px="20px">
        <Flex
          position="relative"
          overflow="hidden"
          flexDirection={{base: 'column', md: 'row'}}
        >
          <Box
            w={{base: '100%', md: '50%', lg: '40%'}}
            pr={{base: 0, md: '30px'}}
          >
            <SlideInBox>
              <Heading fontSize={{base: '25px', md: '36px'}} zIndex={5}>
                Experience Banksy
              </Heading>
            </SlideInBox>
            <SlideInBox>
              <Heading
                color="aqua.700"
                zIndex={5}
                fontSize={{base: '40px', md: '60px'}}
              >
                In real life
              </Heading>
            </SlideInBox>
            <Text mt={{base: '10px', md: '20px'}} mb={{base: '20px', md: '0'}}>
              Enjoy your Banksy with experiential ownership. Not only will you
              be able to view Valentine’s Day Mascara in Dreamland, but
              Showpiece will also inform you of upcoming exclusive events
              whenever the piece is visiting another location. If you are
              looking for something closer to home, we have partnered with
              Futura Art to digitally immerse yourself in Banksy, including
              exploring your very own 360 degree model and the ability to place
              custom stickers within the real world through AR.
            </Text>
          </Box>
          <Box
            w={{base: '100%', md: '50%', lg: '60%'}}
            pl={{base: 0, md: '30px'}}
          >
            <Image
              src="/assets/banksy/experience-banksy.png"
              alt="banksy valentines day mascara"
              maxWidth="100%"
              margin="0 auto"
            />
          </Box>
        </Flex>
      </Box>
    </Center>
  );
};
